import React from 'react';
import { TranslationProps, WithCoreProps } from 'ff-shared-components-core';
import './pageScreen.less';

export interface PageScreenProps {
	name?: string;
	header?: () => React.ReactNode;
	footer?: () => React.ReactNode;
}

export type PageScreenInjectedProps = TranslationProps;

class PageScreenComponent extends React.Component<PageScreenProps & PageScreenInjectedProps> {
	render(): React.ReactNode {
		const { name, header, children } = this.props;

		const cssClass = `page-screen${name ? ' screen-' + name : ''}`;

		return (
			<div className={cssClass}>
				{header && <div className="screen-header">{header()}</div>}
				<div className="screen-body">{children}</div>
			</div>
		);
	}
}

export const PageScreen = WithCoreProps<PageScreenProps>(PageScreenComponent);
